import { render } from "./Film.vue?vue&type=template&id=b9c6b836"
import script from "./Film.vue?vue&type=script&lang=js"
export * from "./Film.vue?vue&type=script&lang=js"

import exportComponent from "/Users/admin/Repositories/dombois-windfilme/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__